import { render, staticRenderFns } from "./StructureCard.vue?vue&type=template&id=78b4ef61"
import script from "./StructureCard.vue?vue&type=script&lang=js"
export * from "./StructureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports